import { render, staticRenderFns } from "./AddMediaGalleryDialog.vue?vue&type=template&id=2094788c&scoped=true&"
import script from "./AddMediaGalleryDialog.vue?vue&type=script&lang=ts&"
export * from "./AddMediaGalleryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddMediaGalleryDialog.vue?vue&type=style&index=0&id=2094788c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2094788c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VFabTransition,VFileInput,VIcon,VImg,VRow,VSheet})
